export const uuid = () => Math.random().toString(36).slice(-6);
//# sourceMappingURL=utils.js.map